import { RootAction } from '@src/app/_redux';
import { ACCT_POSTAL_CODE_LOGIN_INITIATE } from '@src/app/login/weak/accountpostalcode/actions';
import { combineReducers } from 'redux';

export type State = {
  accountNumber: string;
  postalCode: string;
  captureEmail: string;
  emailOptIn: string;
};

export const reducer = combineReducers<State, RootAction>({
  accountNumber: (state = '', action) => {
    switch (action.type) {
      case ACCT_POSTAL_CODE_LOGIN_INITIATE:
        return action.payload.accountNumber;
      default:
        return state;
    }
  },
  postalCode: (state = '', action) => {
    switch (action.type) {
      case ACCT_POSTAL_CODE_LOGIN_INITIATE:
        return action.payload.postalCode;
      default:
        return state;
    }
  },
  captureEmail: (state = '', action) => {
    switch (action.type) {
      case ACCT_POSTAL_CODE_LOGIN_INITIATE:
        return action.payload.captureEmail;
      default:
        return state;
    }
  },
  emailOptIn: (state = '', action) => {
    switch (action.type) {
      case ACCT_POSTAL_CODE_LOGIN_INITIATE:
        return action.payload.emailOptIn;
      default:
        return state;
    }
  },
});
